import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import topic from 'dojo/topic';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './MessageCenter.html?raw';
import Message from '../../Operations/MessageCenter/Message';

import MessageRow from '../../UI/MessageCenter/MessageRow';
import MessageDisplay from '../MessageCenter/MessageDisplay';


interface MessageEntry {
    messageData: Message;
    //node: HTMLElement;
    row: MdsLax<InstanceType<typeof MessageRow>>;

}

class MessageCenter extends compose(_WidgetBaseSP) {
    templateString: any = template;

    messageEntryContainer: HTMLDivElement;
    dlgContainer: HTMLDivElement;
    txtUnreadMessageCount: HTMLSpanElement;

    _messageDisplay: MdsLax<InstanceType<typeof MessageDisplay>>;

    protected _messageEntries: Array<MessageEntry>;
    protected _unreadCount: number;

    protected _displayQueue: Array<Message>;

    private bDoReceive: boolean = true;


    protected _onMessageListenerLoaded(newMessages: Array<Message>, updatedMessages: Array<Message>, allReceivedMessages: Array<Message>, unreadMessageCount: number): void {
        if (this.bDoReceive !== true) {
            return;
        }

        console.log("MessageCenter _onMessageListenerLoaded", newMessages, updatedMessages, allReceivedMessages);        

        this._updateUnreadCount(unreadMessageCount);        

        for (var i = 0; i < newMessages.length; i++) {
            let entry = this.addMessage(newMessages[i]);
            this._drawMessage(entry);
        }

        for (var i = 0; i < updatedMessages.length; i++) {
            let entry = this.getEntryByMessageId(updatedMessages[i].ID);
            if (entry != null) {
                entry.messageData = updatedMessages[i];
                this._drawMessage(entry);
            }
        }

        let presetGuid = this.getUrlParameterValue("guid")
        if (presetGuid != false) {
            this.showMessage(presetGuid);
            this.removeUrlParameter("guid");
        }
        
    }

    _onMessageConfirmed(newMessageData: Message) {
        let entry = this.getEntryByMessageId(newMessageData.ID);
        let previousCount = this._unreadCount;
        if (entry.messageData.is_marked_as_read != true) {
            previousCount--;
        }
        if (entry != null) {
            entry.messageData = newMessageData;
            if (newMessageData.is_marked_as_read != true) {
                previousCount++;
            }
            this._drawMessage(entry);

            this._updateUnreadCount(previousCount);
        }

    }

    _updateUnreadCount(newCount: number) {
        this._unreadCount = newCount;
        this.txtUnreadMessageCount.innerHTML = this._unreadCount.toString();
    }

    redrawMessages(): void {
        this.UiModder.domConstruct.empty(this.messageEntryContainer);

        console.debug("MessageCenter redrawMessages", this._messageEntries);
        
        for (var i = 0; i < this._messageEntries.length; i++) {
            this._messageEntries[i].row.destroy();// = null;
            this._drawMessage(this._messageEntries[i]);
        }
 
    }

/**
* Einen Nachrichteneintrag in der Liste zeichnen oder, falls bereits als Node vorhanden, updaten.
*/
    protected _drawMessage(messageEntry: MessageEntry): void {
        console.debug("MessageCenter _drawMessage", messageEntry);

        let row: MdsLax<InstanceType<typeof MessageRow>> = null;
        if (messageEntry.row == null) {
            row = new MessageRow();
            row.parentWidget = this;
            this.UiModder.domConstruct.place(row.domNode, this.messageEntryContainer);
            messageEntry.row = row;
        }

        messageEntry.row.drawMessage(messageEntry.messageData);        
    }

    addMessage(messageData: Message, draw?: boolean): MessageEntry {

        let entry: MessageEntry = this.getEntryByMessageId(messageData.ID);

        if (entry == null) {
            entry = {
                messageData: messageData,
                    row: null
            };
        }

        this._messageEntries.push(entry);

        if (entry.row == null && draw === true) {
            this._drawMessage(entry);
        }

        return entry;
    }

    removeMessageEntry(message: MessageEntry): boolean {
        if (message == null) return false;

        let entry = this.getEntryByMessageId(message.messageData.ID);
    }

    getEntryByMessageId(messageID: string): MessageEntry {
        for (var i = 0; i < this._messageEntries.length; i++) {
            if (this._messageEntries[i].messageData.ID == messageID || this._messageEntries[i].messageData.identifier_key == messageID) {
                return this._messageEntries[i];
            }
        }

        return null;
    }

    showMessage(messageOrId: string | MessageEntry): void {

        console.log("MessageCenter showMessage", messageOrId);

        let message: MessageEntry;
        if (typeof (messageOrId) == "string") {
            message = this.getEntryByMessageId(messageOrId);
        } else {
            message = messageOrId;
        }

        if (messageOrId == null) {
            return;
        }

        console.debug("MessageCenter showMessage", message, this._messageEntries);

        if (this._messageDisplay == null) {
            this._messageDisplay = new MessageDisplay();
            this.UiModder.domConstruct.place(this._messageDisplay.domNode, this.dlgContainer);
        }

        this._messageDisplay.setMessage(message.messageData, true);
    }

    protected _setupSubscriptions(): void {
        this._topics.push(topic.subscribe("Messages/Loaded", lang.hitch(this, this._onMessageListenerLoaded)));
        this._topics.push(topic.subscribe("Messages/Confirmed", lang.hitch(this, this._onMessageConfirmed)));
    }

    protected _onClick_DebugButtonStop(): void {
        this.bDoReceive = false;
    }

    protected _onClick_DebugButtonStart(): void {
        this.bDoReceive = true;
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this._messageEntries = [];
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(MessageCenter);